// Потолок фильтра `ids` листинга проекта: без него `ids`+`getAllRows` выгрузили бы проект целиком.
export const PROJECT_PHOTOS_MAX_IDS = 100;

// Форма id кадра — одна на фронт и на шлюз, как у `ParseUUIDPipe('all')`: свободный hex без версии/варианта.
// Строгая `v4` завернула бы живые v5-оригиналы prod.
const PROJECT_PHOTO_ID_SHAPE = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

export function isProjectPhotoId(id: unknown): id is string {
  return typeof id === 'string' && PROJECT_PHOTO_ID_SHAPE.test(id);
}
